export default "__VITE_ASSET__DVVn1KSz__"